// @flow
import React from 'react';
import stylesheet from './VisuallyHiddenText.scss';

type Props = {
  text: string,
};

/**
 * **Usage**
 *
 * Typically used to add screen readable text to buttons that have no visible text.
 *
 * i.e icon only buttons
 */
const VisuallyHiddenText = ({ text }: Props) => (
  <div className={stylesheet['visually-hidden-text']}>{text}</div>
);

export default VisuallyHiddenText;
